import script from "./single-file-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./single-file-upload.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__